const testimonials = [
  {
    quote: 'They captured the way the day felt, not just how it looked. Every time we open our gallery, we are right back there.',
    names: 'Ella & James',
    place: 'Hudson Valley, New York',
  },
  {
    quote: 'We barely noticed the camera all day — and yet every single moment we treasure is there. It felt like a friend documenting our story.',
    names: 'Sofia & Marco',
    place: 'Tuscany, Italy',
  },
  {
    quote: 'Quiet, calm and endlessly thoughtful. The photographs are so honest it almost hurts to look at them. We could not recommend anyone more.',
    names: 'Amara & Theo',
    place: 'Big Sur, California',
  },
];

export default testimonials;
